import { Link } from "react-router-dom";
import useScrollAnimation from "../../../hooks/useScrollAnimation";

const HomeCtaSection = () => {
  const sectionRef = useScrollAnimation();

  return (
    <section
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="bg-black py-24 md:py-44 px-6 md:px-16 relative overflow-hidden border-t border-white/5"
    >
      {/* Large background radial glow */}
      <div
        className="glow-pulse absolute pointer-events-none"
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(800px, 90vw)",
          height: "min(800px, 90vw)",
          background: "radial-gradient(ellipse at center, rgba(255,209,0,0.07) 0%, rgba(255,209,0,0.02) 45%, transparent 70%)",
          borderRadius: "50%",
        }}
      />

      {/* Structural lines */}
      <div className="absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-transparent via-[#FFD100]/8 to-transparent pointer-events-none" />
      <div className="absolute left-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#FFD100]/8 to-transparent pointer-events-none ml-16 hidden md:block" />
      <div className="absolute right-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#FFD100]/8 to-transparent pointer-events-none mr-16 hidden md:block" />

      {/* Corner diamonds */}
      <div
        className="absolute border border-[#FFD100]/20 hidden md:block"
        style={{ top: "24px", left: "64px", width: 10, height: 10, transform: "rotate(45deg)" }}
      />
      <div
        className="absolute border border-[#FFD100]/20 hidden md:block"
        style={{ top: "24px", right: "64px", width: 10, height: 10, transform: "rotate(45deg)" }}
      />
      <div
        className="absolute border border-[#FFD100]/20 hidden md:block"
        style={{ bottom: "24px", left: "64px", width: 10, height: 10, transform: "rotate(45deg)" }}
      />
      <div
        className="absolute border border-[#FFD100]/20 hidden md:block"
        style={{ bottom: "24px", right: "64px", width: 10, height: 10, transform: "rotate(45deg)" }}
      />

      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Flanking lines */}
        <div className="reveal flex items-center justify-center gap-6 mb-10">
          <div className="w-24 md:w-40 h-px bg-gradient-to-r from-transparent to-[#FFD100]/50" />
          <div className="w-1.5 h-1.5 rotate-45 bg-[#FFD100]/70 flex-shrink-0" />
          <span
            className="text-[#FFD100] text-xs tracking-[4px] font-bold whitespace-nowrap"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            READY TO SCALE
          </span>
          <div className="w-1.5 h-1.5 rotate-45 bg-[#FFD100]/70 flex-shrink-0" />
          <div className="w-24 md:w-40 h-px bg-gradient-to-l from-transparent to-[#FFD100]/50" />
        </div>

        <h2
          className="reveal delay-100 text-white font-black uppercase leading-tight mb-8"
          style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "clamp(2.2rem, 5vw, 4.5rem)",
            letterSpacing: "-1px",
            lineHeight: "1.05",
          }}
        >
          STOP LOSING PATIENTS.
          <br />
          <span className="text-[#FFD100]">START BUILDING SYSTEMS.</span>
        </h2>

        <p
          className="reveal delay-200 text-[#E5E5E5] text-sm md:text-base max-w-xl mx-auto mb-14"
          style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.85" }}
        >
          Every day without a structured patient acquisition system is revenue leaving
          through the front door. Book your free growth audit and see what you&apos;re leaving
          on the table.
        </p>

        <div className="reveal delay-300">
          <Link
            to="/contact"
            className="group inline-flex items-center gap-3 bg-[#FFD100] text-black text-xs font-black tracking-[3px] px-12 py-5 cursor-pointer whitespace-nowrap hover:bg-white transition-all duration-300"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            BOOK YOUR GROWTH AUDIT
            <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeCtaSection;
